import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={onClose} data-id="element-33">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" data-id="element-34" />

      {/* Modal */}
      <div className="relative z-10 w-full max-w-2xl max-h-[80vh] rounded-2xl overflow-hidden flex flex-col" style={{
      background: '#111827',
      border: '1px solid rgba(212,168,83,0.2)'
    }} onClick={e => e.stopPropagation()} data-id="element-35">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b" style={{
        borderColor: 'rgba(212,168,83,0.15)'
      }} data-id="element-36">
          <h3 className="text-xl font-bold" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#D4A853'
        }} data-id="element-37">
            {title}
          </h3>
          <button onClick={onClose} className="p-1 rounded-lg transition-colors hover:bg-white/10" data-id="element-38">
            <XIcon style={{
            color: '#C8C0B0',
            width: 20,
            height: 20
          }} data-id="element-39" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-6 overflow-y-auto text-sm leading-relaxed space-y-4" style={{
        fontFamily: 'DM Sans, sans-serif',
        color: '#C8C0B0'
      }} data-id="element-40">
          {children}
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="w-full py-12 px-6 border-t" style={{
      background: '#111827',
      borderColor: 'rgba(212,168,83,0.1)'
    }} data-id="element-41">
        <div className="max-w-4xl mx-auto text-center" data-id="element-42">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm font-medium" style={{
          fontFamily: 'DM Sans, sans-serif',
          color: '#8A8070'
        }} data-id="element-43">
            <span className="flex items-center gap-2" data-id="element-44">
              🔒 Paiement 100% sécurisé
            </span>
            <span className="hidden md:inline text-amber-500/30" data-id="element-45">•</span>
            <span className="flex items-center gap-2" data-id="element-46">
              📩 Livraison instantanée par email
            </span>
            <span className="hidden md:inline text-amber-500/30" data-id="element-47">•</span>
            <span className="flex items-center gap-2" data-id="element-48">
              💚 Satisfaite ou remboursée — 30 jours
            </span>
          </div>

          {/* Legal links */}
          <div className="flex justify-center items-center gap-6 mt-6 text-xs" style={{
          fontFamily: 'DM Sans, sans-serif',
          color: '#6B6060'
        }} data-id="element-49">
            <button onClick={() => setPrivacyOpen(true)} className="underline underline-offset-2 hover:text-amber-500 transition-colors cursor-pointer" data-id="element-50">
              Politique de confidentialité
            </button>
            <span className="text-amber-500/30" data-id="element-51">•</span>
            <button onClick={() => setTermsOpen(true)} className="underline underline-offset-2 hover:text-amber-500 transition-colors cursor-pointer" data-id="element-52">
              Conditions générales de vente
            </button>
          </div>

          <p className="mt-6 text-xs" style={{
          fontFamily: 'DM Sans, sans-serif',
          color: '#4A4A4A'
        }} data-id="element-53">
            © {new Date().getFullYear()} Redevenir Moi. Tous droits réservés.
          </p>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Politique de confidentialité" data-id="element-54">
        <p className="font-bold" style={{
        color: '#F5F0E8'
      }} data-id="element-55">
          Dernière mise à jour : avril 2025
        </p>
        <p data-id="element-56">
          La protection de vos données personnelles est une priorité. Cette
          politique explique comment nous collectons, utilisons et protégeons
          vos informations.
        </p>

        <h4 className="font-bold mt-4" style={{
        color: '#F5F0E8'
      }} data-id="element-57">
          1. Données collectées
        </h4>
        <p data-id="element-58">
          Lors de votre achat, nous collectons uniquement les informations
          nécessaires au traitement de votre commande : adresse email et
          informations de paiement (traitées de manière sécurisée par notre
          processeur de paiement Shopify).
        </p>

        <h4 className="font-bold mt-4" style={{
        color: '#F5F0E8'
      }} data-id="element-59">
          2. Utilisation des données
        </h4>
        <p data-id="element-60">Vos données sont utilisées exclusivement pour :</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-61">
          <li data-id="element-62">Vous livrer votre produit numérique par email</li>
          <li data-id="element-63">Assurer le service après-vente et la garantie</li>
          <li data-id="element-64">
            Vous envoyer des communications liées à votre achat (uniquement si
            vous y consentez)
          </li>
        </ul>

        <h4 className="font-bold mt-4" style={{
        color: '#F5F0E8'
      }} data-id="element-65">
          3. Partage des données
        </h4>
        <p data-id="element-66">
          Nous ne vendons, ne louons et ne partageons jamais vos données
          personnelles avec des tiers, sauf obligation légale.
        </p>

        <h4 className="font-bold mt-4" style={{
        color: '#F5F0E8'
      }} data-id="element-67">
          4. Cookies et suivi
        </h4>
        <p data-id="element-68">
          Nous utilisons le Meta Pixel à des fins d'analyse et de publicité.
          Aucune donnée personnelle identifiable n'est partagée via ces outils.
        </p>

        <h4 className="font-bold mt-4" style={{
        color: '#F5F0E8'
      }} data-id="element-69">
          5. Sécurité
        </h4>
        <p data-id="element-70">
          Toutes les transactions sont sécurisées via SSL. Vos informations de
          paiement ne sont jamais stockées sur nos serveurs.
        </p>

        <h4 className="font-bold mt-4" style={{
        color: '#F5F0E8'
      }} data-id="element-71">
          6. Vos droits
        </h4>
        <p data-id="element-72">
          Vous pouvez à tout moment demander l'accès, la modification ou la
          suppression de vos données personnelles en nous contactant par email.
        </p>
      </LegalModal>

      {/* Terms Modal */}
      <LegalModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Conditions générales de vente" data-id="element-73">
        <p className="font-bold" style={{
        color: '#F5F0E8'
      }} data-id="element-74">
          Dernière mise à jour : avril 2025
        </p>
        <p data-id="element-75">
          En effectuant un achat sur ce site, vous acceptez les présentes
          conditions générales de vente.
        </p>

        <h4 className="font-bold mt-4" style={{
        color: '#F5F0E8'
      }} data-id="element-76">
          1. Produit
        </h4>
        <p data-id="element-77">
          « La Méthode OFF » est un produit numérique (ebook + bonus) livré par
          email immédiatement après le paiement. Il s'agit d'un guide
          d'organisation personnelle et ne constitue pas un avis médical ou
          thérapeutique.
        </p>

        <h4 className="font-bold mt-4" style={{
        color: '#F5F0E8'
      }} data-id="element-78">
          2. Prix et paiement
        </h4>
        <p data-id="element-79">
          Le prix affiché est en dollars canadiens (CAD), taxes incluses. Le
          paiement est traité de manière sécurisée via Shopify Payments.
        </p>

        <h4 className="font-bold mt-4" style={{
        color: '#F5F0E8'
      }} data-id="element-80">
          3. Livraison
        </h4>
        <p data-id="element-81">
          Le produit est livré instantanément par email à l'adresse fournie lors
          de l'achat. Aucune livraison physique n'est effectuée.
        </p>

        <h4 className="font-bold mt-4" style={{
        color: '#F5F0E8'
      }} data-id="element-82">
          4. Garantie de remboursement
        </h4>
        <p data-id="element-83">
          Vous bénéficiez d'une garantie satisfaite ou remboursée de 30 jours à
          compter de la date d'achat. Si le produit ne vous convient pas, il
          vous suffit de nous envoyer un email pour obtenir un remboursement
          complet, sans condition.
        </p>

        <h4 className="font-bold mt-4" style={{
        color: '#F5F0E8'
      }} data-id="element-84">
          5. Propriété intellectuelle
        </h4>
        <p data-id="element-85">
          Tout le contenu du guide (textes, images, méthodes) est protégé par le
          droit d'auteur. L'achat vous donne un droit d'utilisation personnel et
          non transférable. La reproduction, la redistribution ou la revente du
          contenu est strictement interdite.
        </p>

        <h4 className="font-bold mt-4" style={{
        color: '#F5F0E8'
      }} data-id="element-86">
          6. Limitation de responsabilité
        </h4>
        <p data-id="element-87">
          Les résultats peuvent varier d'une personne à l'autre. Nous ne
          garantissons aucun résultat spécifique. Ce guide ne remplace pas un
          suivi médical ou psychologique professionnel.
        </p>
      </LegalModal>
    </>;
}